import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import useCategories from "../../Lib/usefetchCategories";
import { AuthContext } from "../../Context/AuthContext";
import Skeleton from "react-loading-skeleton";
import { BsFilter } from "react-icons/bs";
import { TiArrowSortedUp, TiArrowSortedDown } from "react-icons/ti";
import "react-loading-skeleton/dist/skeleton.css";
import "./our_vessels.css";

const OurVessels = () => {
  const { isAuthenticated, token } = useContext(AuthContext);
  const { data: categoriesResponse, isLoading, error } = useCategories();
  
  // State for filter sections
  const [expandedSections, setExpandedSections] = useState({
    type: true,
    paxAccommodation: false,
    use: false,
    price: false,
    paymentPlan: false,
    classification: false
  });

  // State for selected filters
  const [selectedFilters, setSelectedFilters] = useState({
    type: [],
    paxAccommodation: [],
    use: [],
    price: [],
    paymentPlan: [],
    classification: []
  });

  // Toggle section expansion
  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  // Handle filter selection
  const handleFilterSelect = (category, value) => {
    setSelectedFilters(prev => {
      const currentFilters = prev[category];
      const newFilters = currentFilters.includes(value)
        ? currentFilters.filter(filter => filter !== value)
        : [...currentFilters, value];
      
      return {
        ...prev,
        [category]: newFilters
      };
    });
  };

  const categories = categoriesResponse?.data || [];
  const vessels = [
    {
      id: 1,
      name: "ASD Tug 'Navigator'",
      type: "Anchor",
      specifications: [
        "48T Bollard Pull",
        "18 Pax Accommodation",
        "125 m² Deck Space",
        "57T/m² Deck Strength",
        "4,200 BHP",
        "Classification : ABS",
      ],
      price: "$2000/Day",
      paxAccommodation: "18",
      use: "Commercial",
      paymentPlan: "Daily",
      classification: "ABS",
      image: "https://res.cloudinary.com/dquhjbqzf/image/upload/v1725646641/Rectangle_206004_pyb09n.png",
    },
    {
      id: 2,
      name: "ASD Tug 'Navigator'",
      type: "Security",
      specifications: [
        "48T Bollard Pull",
        "18 Pax Accommodation",
        "125 m² Deck Space",
        "57T/m² Deck Strength",
        "4,200 BHP",
        "Classification : ABS",
      ],
      price: "$2000/Day",
      paxAccommodation: "18",
      use: "Military",
      paymentPlan: "Weekly",
      classification: "DNV",
      image: "https://res.cloudinary.com/dquhjbqzf/image/upload/v1725646641/Rectangle_206004_pyb09n.png",
    },
    {
      id: 3,
      name: "ASD Tug 'Navigator'",
      type: "Radioactive",
      specifications: [
        "48T Bollard Pull",
        "18 Pax Accommodation",
        "125 m² Deck Space",
        "57T/m² Deck Strength",
        "4,200 BHP",
        "Classification : ABS",
      ],
      price: "$2000/Day",
      paxAccommodation: "18",
      use: "Private",
      paymentPlan: "Monthly",
      classification: "Lloyd's Register",
      image: "https://res.cloudinary.com/dquhjbqzf/image/upload/v1725646641/Rectangle_206004_pyb09n.png",
    },
  ];

  // Filter options
  const filterOptions = {
    type: ["Radioactive", "Anchor", "Security"],
    paxAccommodation: ["10-20", "21-30", "31-40", "41+"],
    use: ["Commercial", "Private", "Military"],
    price: ["$1000-$2000", "$2001-$3000", "$3001+"],
    paymentPlan: ["Daily", "Weekly", "Monthly"],
    classification: ["ABS", "DNV", "Lloyd's Register"]
  };

  // Filter vessels based on selected filters
  const filterVessels = (vessels) => {
    return vessels.filter(vessel => {
      // If no filters are selected, show all vessels
      const hasActiveFilters = Object.values(selectedFilters).some(filters => filters.length > 0);
      if (!hasActiveFilters) return true;

      // Check each filter category
      const typeMatch = selectedFilters.type.length === 0 || selectedFilters.type.includes(vessel.type);
      
      const paxMatch = selectedFilters.paxAccommodation.length === 0 || 
        selectedFilters.paxAccommodation.some(range => {
          const [min, max] = range.split("-").map(num => parseInt(num));
          const pax = parseInt(vessel.paxAccommodation);
          if (max === undefined) {
            // Handle "41+" case
            return pax >= min;
          }
          return pax >= min && pax <= max;
        });
      
      const useMatch = selectedFilters.use.length === 0 || selectedFilters.use.includes(vessel.use);
      
      const priceMatch = selectedFilters.price.length === 0 || 
        selectedFilters.price.some(range => {
          const price = parseInt(vessel.price.replace(/[^0-9]/g, ""));
          const [min, max] = range.replace(/[$,]/g, "").split("-").map(num => parseInt(num));
          if (max === undefined) {
            // Handle "$3001+" case
            return price >= min;
          }
          return price >= min && price <= max;
        });
      
      const paymentPlanMatch = selectedFilters.paymentPlan.length === 0 || 
        selectedFilters.paymentPlan.includes(vessel.paymentPlan);
      
      const classificationMatch = selectedFilters.classification.length === 0 || 
        selectedFilters.classification.includes(vessel.classification);

      return typeMatch && paxMatch && useMatch && priceMatch && paymentPlanMatch && classificationMatch;
    });
  };

  // Get filtered vessels
  const filteredVessels = filterVessels(vessels);

  return (
    <div className="our-vessels-container">
      <div className="wrap">
        <div className="sidebar">
          <div className="filters-1">
            <BsFilter />
            <p>Filters</p>
          </div>
          
          {/* Type Section */}
          <div className="type">
            <div onClick={() => toggleSection('type')} style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <p>Type</p>
              {expandedSections.type ? <TiArrowSortedUp /> : <TiArrowSortedDown />}
            </div>
            {expandedSections.type && (
              <div className="filter-category">
                {filterOptions.type.map(option => (
                  <button
                    key={option}
                    onClick={() => handleFilterSelect('type', option)}
                    className={selectedFilters.type.includes(option) ? 'selected' : ''}
                  >
                    {option}
                  </button>
                ))}
                {/* Add an empty button if odd number of options to maintain grid layout */}
                {filterOptions.type.length % 2 !== 0 && <div className="empty-grid-cell"></div>}
              </div>
            )}
          </div>

          <div className="filters">
            <ul>
              {Object.entries({
                paxAccommodation: "PAX ACCOMODATION",
                use: "USE",
                price: "PRICE",
                paymentPlan: "PAYMENT PLAN",
                classification: "CLASSIFICATION"
              }).map(([key, label]) => (
                <li key={key}>
                  <div 
                    onClick={() => toggleSection(key)}
                    style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                  >
                    {label}
                    {expandedSections[key] ? <TiArrowSortedUp className="icon"/> : <TiArrowSortedDown className="icon"/>}
                  </div>
                  {expandedSections[key] && (
                    <div className="filter-options">
                      {filterOptions[key].map(option => (
                        <button
                          key={option}
                          onClick={() => handleFilterSelect(key, option)}
                          className={selectedFilters[key].includes(option) ? 'selected' : ''}
                        >
                          {option}
                        </button>
                      ))}
                      {/* Add an empty button if odd number of options to maintain grid layout */}
                      {filterOptions[key].length % 2 !== 0 && <div className="empty-grid-cell"></div>}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Content */}
        {!isAuthenticated && !token ? (
          <div className="categories-auth-error">
            <h3>Please log in to view categories.</h3>
          </div>
        ) : (
          <div className="content">
            <div className="vessel">
              <div className="links">
                <Link to="/all" className="all-button">
                  All
                </Link>

                {isLoading &&
                  Array.from({ length: 4 }).map((_, idx) => (
                    <Skeleton key={idx} height={40} width={100} style={{ margin: "0px 5px" }} />
                  ))}
                {error && <p>Error fetching categories</p>}

                {categories.length > 0
                  ? categories.map((category) => (
                      <Link key={category} to={`/${category}`}>
                        {category}
                      </Link>
                    ))
                  : !isLoading && <p>No categories available</p>}
              </div>
            </div>
            
            <div className="vessel-list">
                <h3>All Vessels ({filteredVessels.length})</h3>
              {isLoading ? (
                <Skeleton count={4} height={200} />
              ) : filteredVessels.length > 0 ? (
                filteredVessels.map((vessel) => (
                  <div key={vessel.id} className="vessel-card">
                    <div className="vessel-left">
                      <img
                        src={vessel.image}
                        alt={vessel.name}
                        className="vessel-image"
                      />
                    </div>
                    
                    <div className="vessel-info">
                      <h3>{vessel.name}</h3>
                      <p>Specifications</p>
                      <div className="specifications">
                        {vessel.specifications.map((spec, index) => (
                          <p key={index} className="spec-item">{spec}</p>
                        ))}
                      </div>
                    </div>

                    <div className="spec">
                      <p>{vessel.price}</p>
                      <a href="/" onClick={(e) => {
                        e.preventDefault();
                        console.log(`View specification sheet for ${vessel.name}`);
                      }} className="spec-link">
                        View specification sheet
                      </a>
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-results">
                  <p>No vessels match the selected filters</p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OurVessels;

